import * as turf from "@turf/turf"

import { NOTATION_SCALE } from "../../../constants/getNotationConfig"

export function useWeightedAverageGrades(features) {
    if (!features?.length) {
        return null
    }

    const weightedGradesInfo = features.reduce((acc, feature) => {
        const featureGradeGlobal = feature?.gradeGlobal ?? feature.properties?.gradeGlobal
        if (!feature.geometry || typeof (featureGradeGlobal) !== "number") {
            return acc
        }
        const featureLength = turf.length(feature.geometry)
        const featureGradeStructure = feature?.gradeStructure ?? feature.properties?.gradeStructure
        const featureGradeSurface = feature?.gradeSurface ?? feature.properties?.gradeSurface

        return ({
            gradeGlobal: acc.gradeGlobal + featureGradeGlobal * featureLength,
            gradeStructure: acc.gradeStructure + featureGradeStructure * featureLength,
            gradeSurface: acc.gradeSurface + featureGradeSurface * featureLength,
            totalLength: acc.totalLength + featureLength,
        })

    }, { gradeGlobal: null, gradeStructure: null, gradeSurface: null, totalLength: null })

    const {
        gradeGlobal,
        gradeStructure,
        gradeSurface,
        totalLength,
    } = weightedGradesInfo

    const clampGrade = (grade) => Math.min(Math.max(grade, 0), NOTATION_SCALE)

    const averageGrades = {
        gradeGlobal: totalLength ? clampGrade(gradeGlobal / totalLength) : null,
        gradeStructure: totalLength ? clampGrade(gradeStructure / totalLength) : null,
        gradeSurface: totalLength ? clampGrade(gradeSurface / totalLength) : null,
    }

    return averageGrades
}
